export default password => {
  const regex = new RegExp(
    "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})"
  );
  if (!regex.test(password)) {
    return "Password must have at least 1 uppercase, 1 lowercase, 1 number, 1 special character and 8 characters";
  }
  return null;
};
